import awardsMbCo from "./awards-mb-co.png"
import awardsMbEc from "./awards-mb-ec.png"
import awardsMbCl from "./awards-mb-cl.png"
import awardsMbArg from "./awards-mb-arg.png"
import awardsPcCo from "./awards-pc-co.png"
import awardsPcEc from "./awards-pc-ec.png"
import awardsPcArg from "./awards-pc-arg.png"
import awardsPcCl from "./awards-pc-cl.png"

export default {
    awardsMbCo,
    awardsMbEc,
    awardsMbCl,
    awardsMbArg,
    awardsPcCo,
    awardsPcEc,
    awardsPcArg,
    awardsPcCl,
}